<template>
  <div>
    <v-card color="mt-3 pa-2 primary darken-1">
      <v-card-title class="mb-0">
        <v-row v-if="periodDate" class="px-3 mt-2" align="center">
          <v-icon size="16" class="mr-1" color="white">mdi-calendar-outline</v-icon>
          <h6 id="period-date-title" class="white--text">Dados de {{formatDate(periodDate.period[0])}} a {{formatDate(periodDate.period[1])}}</h6>
        </v-row>
      </v-card-title>
      <v-card-title class="mb-0">
        <chart-header
          :authorize="authorize"
          @fullscreenChart="fullscreenChart"
          @printChart="printChart"
          @exportChart="exportChart($event)"
          @exportCSV="exportCSV"
          @exportXLS="exportXLS"
        >
          <template v-slot:title>
            Nível em relação ao vertedouro
          </template>
        </chart-header>
      </v-card-title>

      <v-card-text >
        <level-under-spillway-chart
            ref="levelUnderSpillwayChart"
            :periodDate="periodDate"
            :levelUnderSpillway="levelUnderSpillway"
            :basin="basin"
            @chartRenderComplete="chartRenderComplete($event)"
            v-if="!noData"
        >
        </level-under-spillway-chart>
        <NoData v-if="noData"></NoData>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Highcharts from "highcharts"
import Exporting from 'highcharts/modules/export-data'
import ChartHeader from '../../common/ChartHeader.vue';
import LevelUnderSpillwayChart from './LevelUnderSpillwayChart.vue';
import { levelUnderSpillwayChartAuthorization } from "../../../helpers/chart_export_authorization";
import moment from 'moment';
import NoData from "@/components/common/NoData.vue";
Exporting(Highcharts)
export default {
  name: 'LevelUnderSpillway',
  props:['periodDate', 'basin', 'levelUnderSpillway'],
  components:{
    ChartHeader,
    LevelUnderSpillwayChart,
    NoData
  },
  data:()=>({
    tab: 0,
    chartRendered: undefined,
    loading: false,
    showAnimation: false,
    exportChartAuthorized: undefined,
    authorize: [],
    noData: false
  }),
  watch:{
    levelUnderSpillway(value){
      if(value){
        this.processData();
      }
    }
  },
  methods:{
    processData(){
      setTimeout(()=>{
        if (this.levelUnderSpillway && this.levelUnderSpillway.length > 0) {
          this.noData = false;
          this.$refs.levelUnderSpillwayChart.chartPreprocessing();
          this.authorize = levelUnderSpillwayChartAuthorization;
        } else {
          this.noData = true;
        }
      }, 50);
    },
    chartRenderComplete(chart){
      this.chartRendered = chart;
    },
    exportChart(typeFile){
      this.chartRendered.exportChart({type: typeFile});
    },
    exportCSV(){
      this.chartRendered.downloadCSV();
    },
    exportXLS(){
      this.chartRendered.downloadXLS()
    },
    fullscreenChart(){
      const fullscreenControl = new Highcharts.Fullscreen(this.chartRendered);
      fullscreenControl.open();
    },
    printChart(){
      this.chartRendered.print();
    },
    changeTabItem(tabIndex){
      this.tab = tabIndex;
    },
    formatDate(date){
      const stringFormat = this.periodDate.type === 'Diário' ? 'DD/MM/YYYY' : 'MMMM/YYYY';
      return moment(date).locale('pt-br').format(stringFormat);
    },
  }
}
</script>

<style scoped>
  .tab-item-title{
    color: var(--v-secondary-lighten1) !important;
    border: 1px solid var(--v-secondary-lighten1);
    text-transform: none;
  }
  #tab-volume-hm3{
    border-radius: 4px 0px 0px 4px;
  }
  /* #tab-rain-level{

  } */
  #tab-volume-percentage{
    border-radius: 0px 4px 4px 0px
  }

  #period-date-title{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
  }
</style>
